import { PaymentMethodDetails } from '@components'

import React, { useMemo } from 'react'

import { useOrganizationSubscription } from '../../../../../../hooks'
import { isExpired } from '../../../../../../utils/payment'
import { EditCardSubscriptionParams } from '../../types'
import { OrganizationPaymentMethodSelection } from '../OrganizationPaymentMethodSelection'

export interface BillingSummaryProps {
  isLoading?: boolean
  onEditCardSubscription: (event: EditCardSubscriptionParams) => void
}

export const BillingSummaryComponent = ({ isLoading, onEditCardSubscription }: BillingSummaryProps) => {
  const { cardAdded, cardInvalid, cardType, cardLabel, cardExpirationDate, defaultActivePaymentMethod } =
    useOrganizationSubscription()

  const handleEditCardSubscription = () => {
    onEditCardSubscription({ detail: { cardOnly: true } })
  }

  const paymentMethodDetails: PaymentMethodDetails | undefined = useMemo(
    () =>
      defaultActivePaymentMethod && {
        type: defaultActivePaymentMethod.Type,
        detailType: cardType || 'visa',
        expirationDate: cardExpirationDate || undefined,
        isInvalid: cardInvalid,
        label: cardLabel,
        issuer: defaultActivePaymentMethod.Issuer,
        horizontal: true,
      },
    [defaultActivePaymentMethod, cardExpirationDate, cardInvalid, cardLabel, cardType],
  )

  return (
    <OrganizationPaymentMethodSelection
      paymentMethodDetails={paymentMethodDetails}
      isCardExpired={!!cardExpirationDate && isExpired(cardExpirationDate)}
      isLoading={isLoading}
      isSubscribed={cardAdded}
      onAddPaymentClick={handleEditCardSubscription}
      onUpdatePaymentClick={handleEditCardSubscription}
    />
  )
}
